// === Minimal transient toast ===

export function showToast(message, duration = 2200) {
  const existing = document.querySelector('.app-toast');
  if (existing) existing.remove();
  const toast = document.createElement('div');
  toast.className = 'app-toast';
  toast.setAttribute('role', 'status');
  toast.textContent = message;
  document.body.appendChild(toast);
  setTimeout(() => toast.classList.add('app-toast-out'), Math.max(0, duration - 400));
  setTimeout(() => toast.remove(), duration);
}
